import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api/apiGet';
import {GET_QUESTIONS_ERROR, GET_QUESTIONS_START, GET_QUESTIONS_SUCCESS} from "../../types";

export function* create({payload}) {
  try {
    const url = '/questions/';
    const method = 'GET';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
    const results = yield call(apiCall, url, method, headers);
    yield put({type: GET_QUESTIONS_SUCCESS, results: results.data});
  } catch (error) {
    yield put({type: GET_QUESTIONS_ERROR, error});
  }
}

export default function* questions() {
  yield takeLatest(GET_QUESTIONS_START, create);
}
